import AbstractPage from './abstract-page';
import Picture from '../../picture';

export default class SingleChoice extends AbstractPage {
  constructor(props) {
    super(props);
  }

  render() {
    const question = this.screenData;
    const subHeader = (this.props.data.description) ? <span>{this.props.data.description}</span> : '';
    const questionCounter = (this.progress) ? <h2 class="question-counter">
        <span class="question-counter__title">
          {this.progress.questionNumber}/{this.progress.numberOfQuestion}
        </span>
      </h2> : '';
    const questionTitle = (question.title) ? <h2 className="content__title">{question.title}</h2> : '';
    const questionDescription = (question.description) ? <div className="content__main-text" dangerouslySetInnerHTML={{__html: question.description}} /> : '';
    const listOptions = question.answers.map((answer) => <li className="content__question-list-item"><button className="content__question-item" type="button" onClick={() => this.onNext([answer.next])}>{answer.title}</button></li>);
    return (
      <article className={question.specialClass}>
        <h1 class="title">
          Онлайн-игра
        </h1>

        {subHeader}
        <Picture attributes={{src: question.imageSrc, width: 512, height: 386, alt: ''}} author={question.imageAuthor}/>
        {questionCounter}
        {questionTitle}
        {questionDescription}
        <div className="content__question-form">
          <h2 className="content__question-title">Выберите ответ:</h2>
          <ul className="content__question-list">
            {listOptions}
          </ul>
        </div>
      </article>
    );
  }

  static backDataToModel(step) {
    const result = AbstractPage.backDataToModel(step);
    result.isMultiple = false;
    result.answers = [];
    for (let answer of step.answers) {
      let resultAnswer = {};
      resultAnswer.title = (answer.title) ? answer.title : null;
      resultAnswer.next = (answer.next) ? answer.next : null;
      result.answers.push(resultAnswer);
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./components/page/view/single-choice.jsx